import { render, staticRenderFns } from "./CompanyGroupsEditorCard.vue?vue&type=template&id=40a13622&scoped=true&"
import script from "./CompanyGroupsEditorCard.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupsEditorCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGroupsEditorCard.vue?vue&type=style&index=0&id=40a13622&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a13622",
  null
  
)

export default component.exports